import tmhRequest from '@/config/tmhRequest'

export default {
  searchService: function ( data) {
    return tmhRequest({
      url: '/project/tmh/service/searchservice',
      method: 'post',
      params: data,
    })
  },
  searchListService: function ( data) {
    return tmhRequest({
      url: '/project/tmh/service/searchlistservice',
      method: 'post',
      params: data,
    })
  },
  searchServiceCount: function ( data) {
    return tmhRequest({
      url: '/project/tmh/service/searchservicecount',
      method: 'post',
      params: data,
    })
  },
  searchServiceByPage: function ( data) {
    return tmhRequest({
        url: '/project/tmh/service/searchservicebypage',
      method: 'post',
      params: data,
    })
  },
  addService: function ( data) {
    return tmhRequest({
      url: '/project/tmh/service/addservice',
      method: 'post',
      data: data,
    })
  },

  updateService: function ( data) {
    return tmhRequest({
        url: '/project/tmh/service/updateservice',
      method: 'post',
      data: data,
    })
  },

}


// WEBPACK FOOTER //
// ./src/api/tmh/item/service.js